import { z } from "zod";
import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { useAuthenticationStore } from "@/store/authentication";
import { Loader } from "@/components/layout/loader";
import { useUserOnboarded } from "@/hooks/use-onboarded";

export const Route = createFileRoute("/")({
  validateSearch: z.object({ next: z.string().nullish() }),
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useSearch();
  const navigate = Route.useNavigate();

  const onboarded = useUserOnboarded();
  const user = useAuthenticationStore((state) => state.user);

  useEffect(() => {
    if (!user) {
      navigate({ to: "/auth", params });
    } else {
      navigate({ to: onboarded ? params.next || "/dashboard" : "/onboarding" });
    }
  }, [user, onboarded, params, navigate]);

  return <Loader />;
}
